import { renderElement } from "../../utils/use-render.js";
import { useDialogContext } from "./context.js";
import { forwardRef, useCallback } from "react";
//#region src/ui/dialog/popup.tsx
/** Renders the modal dialog while it is open. */
const DialogPopup = forwardRef(function DialogPopup({ render, className, style, ...elementProps }, forwardedRef) {
	const { core, dialog, state, stateAttrMap, popupId } = useDialogContext();
	const popupRef = useCallback((element) => dialog.setPopupElement(element), [dialog]);
	if (!state.open) return null;
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef, popupRef],
		props: [{
			id: popupId,
			tabIndex: -1,
			...core.getPopupAttrs(state)
		}, elementProps]
	});
});
//#endregion
export { DialogPopup };

//# sourceMappingURL=popup.js.map